<template>
    <div class="fill-height">
        <v-container class="fill-height" fluid>
            <v-row align="center" justify="center">
                <v-card class="elevation-12" outlined width="500">
                    <v-toolbar flat>
                        <v-toolbar-title class="gray--text to-center rpfs">{{ $t('Восстановление пароля') }}</v-toolbar-title>
                    </v-toolbar>

                    <v-card-text class="pb-0">
                        <v-form ref="forgotPasswordForm">
                            <v-text-field
                                outlined
                                prepend-inner-icon="account_circle"
                                v-model="email"
                                label="E-mail"
                                :rules="emailRules"
                                validate-on-blur
                            ></v-text-field>

                            <span style="font-size: 14px" :class="`${messageColor}--text`">{{ $t(message) }}</span>
                        </v-form>
                        <v-btn color="primary" height="50px" class="block mt-5" :style="{ 'font-size': btnFontFize }" @click="sendEmail">
                            {{ $t('Восстановить пароль') }}</v-btn
                        >
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                    </v-card-actions>
                </v-card>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import FormValidator from '../../mixins/FormValidator';
export default {
    data: () => ({
        email: null,
        message: null,
        messageColor: 'red'
    }),
    computed: {
        btnFontFize() {
            return this.$vuetify.breakpoint.xsOnly ? '12px' : '0.875rem';
        }
    },
    mixins: [FormValidator],
    methods: {
        ...mapActions('auth', ['restorePassword', 'logout']),
        async sendEmail() {
            if (!this.$refs.forgotPasswordForm.validate()) return;
            let result = await this.restorePassword({ login: this.email });

            switch (result.message) {
                case 'UserNotFound':
                    this.message = 'Учетная запись не найдена';
                    this.messageColor = 'red';
                    break;
                case 'UserBlockedOrNotActivated':
                    this.message = 'Учетная запись заблокирована. Обратитесь в ТОО «АлТС»';
                    this.messageColor = 'red';
                    break;
                case 'EmailSendedToEmailAddress':
                    this.message = 'На указанный E-mail отправлена ссылка для восстановления пароля';
                    this.messageColor = 'primary';
                    break;
                default:
                    this.message = null;
                    break;
            }
        }
    },
    async mounted() {
        await this.logout({ nonHome: true });
        this.$watch(
            '$i18n.locale',
            (newLocale, oldLocale) => {
                if (newLocale === oldLocale) {
                    return;
                }
                this.$refs.forgotPasswordForm.resetValidation();
            },
            { immediate: true }
        );
    }
};
</script>

<style></style>
